import { render, staticRenderFns } from "./ForgetPassWord.vue?vue&type=template&id=6ba473f1&scoped=true&"
import script from "./forgetpassword.js?vue&type=script&lang=js&"
export * from "./forgetpassword.js?vue&type=script&lang=js&"
import style0 from "./ForgetPassWord.vue?vue&type=style&index=0&id=6ba473f1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba473f1",
  null
  
)

export default component.exports